import Hero from "../../../../src/components/hero";
import * as React from 'react';
export default {
  Hero,
  React
};